var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 0H2.14286C0.964286 0 0 0.942408 0 2.09424V12.5654C0 13.7173 0.964286 14.6597 2.14286 14.6597H2.85714L1.17857 20L8.46429 14.6597H17.8571C19.0357 14.6597 20 13.7173 20 12.5654V2.09424C20 0.942408 19.0357 0 17.8571 0ZM18.5714 12.5654C18.5714 12.9494 18.25 13.2635 17.8571 13.2635H7.96429L3.82143 16.3002L4.78571 13.2635H2.14286C1.75 13.2635 1.42857 12.9494 1.42857 12.5654V2.09424C1.42857 1.7103 1.75 1.39616 2.14286 1.39616H17.8571C18.25 1.39616 18.5714 1.7103 18.5714 2.09424V12.5654Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.123fe20af5399568b34a81b1a0c189e7.svg";
export { ForwardRef as ReactComponent };